import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

import type { ApiResponseMeta } from '../domain/api';

// Here we have flatten meta with pagination, if other objects are passed in meta, we should preserve initial depth
const initialState: ApiResponseMeta = {
    pagination: {
        page: 0,
        pageCount: 1,
        pageSize: 10,
        total: 1
    }
};

const apiResponseMetaSlice = createSlice({
    initialState,
    name: 'apiResponseMeta',
    reducers: {
        clearApiResponseMeta: (state) => {
            state.pagination.page = 1;
            state.pagination.pageSize = 10;
            state.pagination.pageCount = 1;
            state.pagination.total = 1;
        },
        setApiResponseMeta: (state, action: PayloadAction< ApiResponseMeta| null>) => {
            state.pagination.page = action.payload?.pagination.page ?? 1;
            state.pagination.pageSize = action.payload?.pagination.pageSize ?? 10;
            state.pagination.pageCount = action.payload?.pagination.pageCount ?? 1;
            state.pagination.total = action.payload?.pagination.total ?? 1;
        },

    },
});

export const { setApiResponseMeta, clearApiResponseMeta } = apiResponseMetaSlice.actions;
export default apiResponseMetaSlice.reducer;